import { render, staticRenderFns } from "./TableHeadColumn.vue?vue&type=template&id=0bcdbaec&scoped=true&"
import script from "./TableHeadColumn.vue?vue&type=script&lang=js&"
export * from "./TableHeadColumn.vue?vue&type=script&lang=js&"
import style0 from "./TableHeadColumn.vue?vue&type=style&index=0&id=0bcdbaec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcdbaec",
  null
  
)

export default component.exports